import React from "react";
import { useAuthQuery as useQuery } from '../../../../../shared/hooks/useAuthQuery';
import { Button } from "../../../../../catalyst-components/button";
import { Id } from "../../../../../convex/_generated/dataModel";
import { api } from "../../../../../convex/_generated/api";
import { MainRoutes } from "../../../../../shared/models";
import { useNavigate } from "react-router-dom";
import { getDateTIme } from "../../../../../shared/helpers/get-date-time";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../../../../catalyst-components/table";

interface ChatSessionsListProps {
    assistantId: Id<"assistants">
}

export const ChatSessionsList: React.FC<ChatSessionsListProps> = ({ assistantId }) => {
    const sessions = useQuery(api.sessions.listSessionsByAssistant, { assistantId }) || [];
    const navigate = useNavigate();
    return (
        <section className="flex flex-col">
            <span>
                Chats with this assistant (up to last 10):
            </span>

            <Table striped className="w-full">
                <TableHead className="border-b-2 border-primary-2">
                    <TableRow>
                        <TableHeader className="w-32">Actions</TableHeader>
                        <TableHeader className="w-48">Created Date</TableHeader>
                        <TableHeader>User Name</TableHeader>
                        <TableHeader>Temperature</TableHeader>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sessions.map((session) => (
                    <TableRow key={session._id} className="hover:bg-gray-50">
                        <TableCell>
                            <Button
                                color="light"
                                className="w-full"
                                onClick={() => navigate(`${MainRoutes.Chat}?sessionId=${session._id}&name=${session.user?.firstName}`)}>
                                    View Chat
                            </Button>
                        </TableCell>
                        <TableCell>{getDateTIme(session?._creationTime)}</TableCell>
                        <TableCell>
                            {session.user?.firstName} {session.user?.lastName}
                        </TableCell>
                        <TableCell>{session.temperature}</TableCell>
                    </TableRow>
                    ))}
                </TableBody>
            </Table>
        </section>
    )
}